<template>

  <div class="w-[750px] lg:block hidden">
    <div class="grid grid-cols-5 bg-white shadow rounded-[20px] min-h-[82px]">
      <div class="flex text-center align-middle justify-center border-r-[1px] border-[#ADADAD]">
        <p class="capitalize text-[#2699C6] text-[12px] text-center font-semibold" style="align-content: center">
          INFORMACE O VÁS</p>
      </div>
      <div class="col-span-3 align-middle text-left my-auto">
        <p class="px-[25px] text-gray-900 text-[18px] font-semibold" style="line-height: 28px">{{name}}, {{company}}</p>
        <p class="px-[25px] text-gray-900 text-[18px] font-medium" style="line-height: 28px">{{email}}</p>

      </div>
      <div class="flex align-middle items-center">
        <div>
          <form @submit.prevent="logout">
            <button @click="logout" class="bg-[#2699C6] px-[25px] py-[14px] rounded-full shadow text-center text-white text-[16px] font-semibold">
              Odhlásit se
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div class="lg:hidden flex flex-col items-center bg-white shadow rounded-[20px] gap-2 w-full">
    <div class="mt-2">
      <p class="capitalize text-[#2699C6] text-[12px] text-center font-semibold" style="align-content: center">
        INFORMACE O VÁS</p>
    </div>
    <div class="col-span-3 align-middle text-center my-auto">
      <p class="px-[25px] text-gray-900 text-[18px] font-semibold" style="line-height: 28px">{{name}}, {{company}}</p>
      <p class="px-[25px] text-gray-900 text-[18px] font-medium" style="line-height: 28px">{{email}}</p>
    </div>
    <div class="mb-2">
      <form @submit.prevent="logout">
        <button @click="logout" class="bg-[#2699C6] px-[25px] py-[14px] rounded-full shadow text-center text-white text-[16px] font-semibold">
          Odhlásit se
        </button>
      </form>
    </div>
  </div>

</template>

<script>
export default {
  props: {
    name: {
      type: String,
    },
    company: {
      type: String,
    },
    email: {
      type: String,
    }
  },
    setup() {
        const logout = async () => {

        try {
            const res = await axios.post(route("user.logout"), {}, {
            headers: {
                'Accept': 'application/json'
            }
            });

            if(res.status === 200) {
            window.location.href = route("frontend.homepage");
            }
        } catch(err) {}
        }

        return {
            logout
        }
    }
}
</script>

<style>

</style>
